import { useAtom } from "jotai";
import { useState } from "react";

import { Modal } from "../../../shared/components/modal/modal.component";
import { cplOfferPageAtom } from "../../cpl-offer-page.state";
import { moveToNextPage } from "../../utils";

export function CplOfferPageModal({ isOpen }: { isOpen: boolean }) {
  const [cplOfferPage] = useAtom(cplOfferPageAtom);
  const [disabledContinueBtn, setDisabledContinueBtn] = useState(false);

  const handleContinueBtnClick = () => {
    setDisabledContinueBtn(true);
    moveToNextPage();
  };

  return (
    <Modal isOpen={isOpen} className="cpl-offer-page__modal" delay={0}>
      <div className="cpl-offer-page__modal--title">
        Great choice, your offers are on the way to your email address! ️{" "}
      </div>
      <div className="cpl-offer-page__modal--copy">
        YOU’VE EARNED{" "}
        <strong>{cplOfferPage.sessionCplExtraEntries} ENTRIES</strong>{" "}
        <span role="img" aria-label="fire icon">
          🔥
        </span>
      </div>
      <button
        className="cpl-offer-page--btn"
        disabled={disabledContinueBtn}
        onClick={() => handleContinueBtnClick()}
      >
        Continue to earn more entries
      </button>
    </Modal>
  );
}
